import { render, staticRenderFns } from "./FormInputList.vue?vue&type=template&id=0ed209e0&scoped=true"
import script from "./FormInputList.vue?vue&type=script&lang=js"
export * from "./FormInputList.vue?vue&type=script&lang=js"
import style0 from "./FormInputList.vue?vue&type=style&index=0&id=0ed209e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed209e0",
  null
  
)

export default component.exports